import { OutputType } from "../../enums.js";
import { AppSessionCellId, OutputId } from "../../idTypeBrands.js";
import { createAppSessionEventDefinition } from "../AppSessionEventDefinition.js";
import { OutputContent } from "../AppSessionEventState.js";

export const CREATE_OUTPUT = createAppSessionEventDefinition({
  type: "CREATE_OUTPUT",
  logSafe: {
    outputId: true,
    appSessionCellId: true,
    order: true,
    outputType: true,
    requestId: true,
    outputContents: false,
  },
  create: (payload: {
    outputId: OutputId;
    appSessionCellId: AppSessionCellId;
    order: number;
    outputType: OutputType;
    requestId: string | null;
    outputContents: Omit<OutputContent, "outputId">[];
  }) => payload,
  apply: (
    previousState,
    {
      appSessionCellId,
      order,
      outputContents,
      outputId,
      outputType,
      requestId,
    },
  ) => {
    const warnings: string[] = [];

    if (previousState.appSessionCells[appSessionCellId] == null) {
      warnings.push(`App session cell not found: ${appSessionCellId}`);
    }

    if (previousState.outputs[outputId] != null) {
      warnings.push(`Output previously existed, overwriting: ${outputId}`);
    }

    previousState.outputs[outputId] = {
      id: outputId,
      appSessionCellId,
      order,
      outputType,
      requestId,
    };

    for (const outputContent of outputContents) {
      if (previousState.outputContents[outputContent.id] != null) {
        warnings.push(
          `Output content previously existed, overwriting: ${outputContent.id}`,
        );
      }

      previousState.outputContents[outputContent.id] = {
        ...outputContent,
        outputId,
      };
    }

    return { warnings };
  },
});
